import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { EnrollmentNew } from 'src/app/modules/enrollments/models/enrollment-new.model';
import { Class } from 'src/app/modules/classes/models/class.model';
import { ExtraService } from 'src/app/modules/enrollments/models/extra-service.model';
import { EnrollmentPaymentInfo } from 'src/app/modules/enrollments/models/enrollment-paymentinfo.model';
import { EnrollmentPaymentInfoService } from 'src/app/modules/enrollments/services/enrollment-payment-info.service';

@Component({
    selector: 'app-enrollment-edit-step-summary',
    templateUrl: './enrollment-edit-step-summary.component.html',
    styleUrls: ['./enrollment-edit-step-summary.component.scss']
})
export class EnrollmentEditStepSummaryComponent implements OnInit {

    @Input() enrollment: EnrollmentNew;

    @Output() enrollmentChange = new EventEmitter<EnrollmentNew>();
    @Output() isCompleteStep   = new EventEmitter<boolean>();

    public labels: any = {

        stepTitleLabel   : 'Resumen de la inscripción',
        stepSubtitleLabel: 'Revise que todos los datos sean correctos. Para continuar, pulse sobre el botón <strong>Crear inscripción</strong>'

    }

    public isLoadingData : boolean = true;
    public loadingMessage: AlertMessage = new AlertMessage();

    public enrollmentClasses      : Class[];
    public enrollmentExtras       : ExtraService[];
    public enrollmentTotalDiscount: number;
    public enrollmentPaymentInfo  : EnrollmentPaymentInfo;

    constructor(private enrollmentPaymentInfoService: EnrollmentPaymentInfoService) {}

    ngOnInit (): void {

        this.initData();

    }

    private initData() {

        this.isLoadingData = true;

        this.enrollmentClasses = this.enrollment.classes.sort((a: Class, b: Class) => (a.scheduleId > b.scheduleId ? 1 : -1));
        this.enrollmentExtras  = [...new Set(this.enrollmentClasses?.flatMap(d => d.extraServices))];
        this.enrollmentTotalDiscount = this.enrollment.totalDiscount;
        this.enrollmentPaymentInfo = this.enrollmentPaymentInfoService.get(
            this.enrollmentClasses,
            this.enrollmentExtras,
            this.enrollmentTotalDiscount
        );

        this.onEnrollmentChange();
        this.isLoadingData = false;

    }

    public isFormValid() {

        return true;

    }

    public onEnrollmentChange() {

        this.enrollment.paymentInfo = this.enrollmentPaymentInfo;

        this.isCompleteStep.emit(this.isFormValid());
        this.enrollmentChange.emit(this.enrollment);

    }

}
